export default __webpack_public_path__ + "graphics/events-icon-outline.fa92b070.svg";